import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import RestoreIcon from '@material-ui/icons/Restore';
import InfoIcon from '@material-ui/icons/Info';
import PortletToolbar from 'components/PortletToolbar';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';

import Period from '../../../../helpers/PeriodGeneralStatus';
import AvailabilitySimplified from '../../../Online/components/AvailabilitySimplified';
import ResponseTimeSimplified from '../../../Online/components/ResponseTimeSimplified';

import { withTranslation } from 'react-i18next';

import moment from 'moment-timezone'
import 'moment/locale/es'  
import { Select } from '@material-ui/core';
import { fetchObjectivesListData } from '../../../../utils/get-objectives-list-data';
moment.locale('es')
const date=((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
class CompareObjectives extends Component {

    constructor(props) {
        super(props);
        var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
        var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD h:mm:ss"))
        var statePeriod={startDate: startDate,endDate: endDate,key: "selection"}

        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
    const tFunc = (props && props.t) ? props.t : (k => k);
        this.state = {
            isOpen: false,
            path: null,
            listObjectives: {},
            nameStatus: 'Objetivos ',
            selectedOption: null,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            isStatePeriod: false,
            settingsEl: null,
            isInfo: null,
            date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
            objmodal: 0,
            objNameModal: '',
            openObjectiveModal: false,
            typeGraph: 0,
            period: 'd',
            statePeriod: statePeriod,
            namePeriod: null,
            // namePeriodPorlet moved to render()
            isRefresh: false,
            checkedA: sessionStorage.getItem('extend_view') === "true",
            objectiveFirst: null,
            isSecondObjective: false,
            typegraphFirst: 0,
            typegraphSecond: 0,
            isFirstTime: true,
            typegraphResponseFirst: 0,
            typegraphResponseSecond: 0,
            intervalId: null,
        }

    }
    tick=()=>{
        sessionStorage.setItem("listsLoadsDisponibilidad", false)
        const newState = { ...this.state }; 
        newState['isFirstTime'] = false
        newState['date'] = moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")
        this.setState(newState);
        this.processData()
      }

    componentDidMount() {
        this.processData()
        const newInterval = setInterval(
            () => this.tick(),
            300000
        )
        this.setState({intervalId: newInterval})
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (!this.state.loadObjectiveData) {   
            this.processData()
        }        
    }
    

    processData = async () => {
        const { params } = this.props;
        const {objectiveFirst, objectiveSecond, isFirstTime} = this.state;
        let data = params
        var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4};
        data = data.sort(function (a, b) {
            return (order[a.estado] - order[b.estado]);
        });
        this.setState({
            objectivesList: data,
            loadObjectiveData: true,
            listObjetivesData: data,
            isLoading: false,
            params: data,
            isRefresh: false,
            objectiveFirst: isFirstTime ? data[0] : objectiveFirst,
            objectiveSecond: isFirstTime ? data.length > 1 ? data[1] : data[0] : objectiveSecond,
        });

    }

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleChange = (selectedOption) => {
        const { passProps } = this.props
        this.setState({ selectedOption });
        //passProps.onClick(passProps, selectedOption.value)
    };
    
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleRefresh = () => {
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: true
        });
    };
    handleDefault = () => {
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: false,
            typePeriod: 4
        });
    };

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {

        if (nextPeriod === 'hora') {

            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}  
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: última hora',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'hour').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 1,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '6hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(6,'hour').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: '6h',
                typePeriod: 2,
                namePeriod: 'Rango: últimas 6 horas',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '12hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(12,'hour').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: '12h',
                typePeriod: 3,
                namePeriod: 'Rango: últimas 12 horas',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 4,
                namePeriod: 'Rango: último día',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '2dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(2,'day').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "2d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 2 días',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'week').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 6,
                namePeriod: 'Rango: última semana',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '2semana') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(2,'week').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "2w",
                typePeriod: 7,
                namePeriod: 'Rango: última semana',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'mes') {
            const startDateMonth=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'month').format("YYYY-MM-DD h:mm:ss"))
            const endDateMonth=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDateMonth,endDate: endDateMonth,key: "selection"}

            this.setState({
                typeGraph: prevTypeGraph,
                period: "m",
                typePeriod: 8,
                namePeriod: 'Rango: último mes',
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState['objective'+field] = value;   
        this.setState(newState);
    };

    handleTypegraph = (field, value) => {
        const newState = { ...this.state };
        newState[field] = value;   
        this.setState(newState);
    };

    render() {
        const { chartOptions, isLoading, date, settingsEl, isInfo, objectivesList, loadObjectiveData, periodEl, 
            typeGraph, period, isOneHour, typePeriod, checkedA, objectiveFirst, isSecondObjective}= this.state;
        const { classes, className, handleClose, isForModal, ...rest } = this.props;
        const { t } = this.props || { t: (k)=>k };
        const namePeriodPorlet = [
            (t && typeof t === 'function' ? t('period.text.last-hour') : 'Última Hora') || 'Última Hora',
            (t && typeof t === 'function' ? t('period.text.last-3-hours') : 'Últimas 3 horas') || 'Últimas 3 horas',
            (t && typeof t === 'function' ? t('period.text.last-6-hours') : 'Últimas 6 horas') || 'Últimas 6 horas',
            (t && typeof t === 'function' ? t('period.text.last-12-hours') : 'Últimas 12 horas') || 'Últimas 12 horas',
            (t && typeof t === 'function' ? t('period.text.last-day') : 'Último día') || 'Último día',
            (t && typeof t === 'function' ? t('period.text.last-2-days') : 'Últimos 2 días') || 'Últimos 2 días',
            (t && typeof t === 'function' ? t('period.text.last-week') : 'Última semana') || 'Última semana',
            (t && typeof t === 'function' ? t('period.text.last-2-weeks') : 'Últimas 2 semanas') || 'Últimas 2 semanas',
            (t && typeof t === 'function' ? t('period.text.last-month') : 'Último mes') || 'Último mes',
            (t && typeof t === 'function' ? t('period.text.select') : 'Seleccione Período') || 'Seleccione Período'
        ];
        const style = isLoading ? { display: 'none' } : {maxWidth:'100vw', padding:'0px'};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const rootClassName = classNames(classes.root, className);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        let isForModalEl = false
        if (isForModal == true){
            isForModalEl = true
        }
        return (
            <Portlet className={rootClassName}>
                <PortletHeader className={classes.header}>
                {/* <PortletLabel
                            variant="h6"
                            title="Estado General"
                        /> */}
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                            <Hidden only={["xs", 'sm']}><Avatar variant="rounded" className={classes.rounded}>
                            <UpdateIcon /> 
                            </Avatar>
                            <Typography  className={classes.updateTime}   >
                                &nbsp; {t('text.last-update') || 'Última actualización'}: {date} 
                            </Typography></Hidden>
                        </div>
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                             <Button variant="h4" style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                                {(namePeriodPorlet[typePeriod] && namePeriodPorlet[typePeriod] !== '') ? namePeriodPorlet[typePeriod] : ((t && typeof t === 'function') ? t('period.text.last-day') : 'Último día')}
                                <ArrowDropDownIcon />
                            </Button>
                            <IconButton
                                onClick={this.handleShowSettings}
                                styles={{float:'right'}}
                            >
                                <SettingsOutlinedIcon />
                            </IconButton>
                            {isForModalEl ?
                                <IconButton 
                                    onClick={handleClose}
                                >
                                    <ClearIcon/>
                                </IconButton>
                            : null}
                        </div>
                    <Popover
                        anchorEl={periodEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleClosePeriod}
                        open={showPeriodEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={isOneHour}/>
                    </Popover>
                    <Popover
                        anchorEl={settingsEl}
                        onClose={this.handleCloseSettings}
                        open={showSettingsEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                            }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                    }}
                    >
                        <IconButton color="primary" style={{display: 'flex', justifyContent: 'space-between', color:'#66788A'}} onClick={this.handleRefresh}>
                            <RefreshIcon color="primary" style={{ color:'#66788A'}} />
                            <Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                {t('text.update') || 'Actualizar'}
                            </Typography>
                        </IconButton>
                        <IconButton color="primary" style={{display: 'flex', justifyContent: 'space-between'}} onClick={this.handleDefault}>
                            <RestoreIcon color="primary" style={{ color:'#66788A'}} />
                            <Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                {t('period.text.default') || 'Periodo por Defecto'}
                            </Typography> 
                        </IconButton>             
                </Popover>
                </PortletHeader>
                <PortletContent className={classes.content}>
                    {loadObjectiveData ?
                        <FormattedChart 
                            params={this.state}
                            period={period}
                            handleOpen={this.handleOpenObjectiveModal}
                            listObjectives={objectivesList} 
                            chartOptions={chartOptions} 
                            style={style} styleHidden={styleHidden} classes={classes} date={date}
                            checkedA={checkedA}
                            handleFieldChange={this.handleFieldChange}
                            isSecondObjective={isSecondObjective}
                            handleTypegraph={this.handleTypegraph}
                            objectiveFirst={objectiveFirst}
                            objectiveSecond={this.state.objectiveSecond}
                            t={t}
                        />
                    :   <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                                <CircularProgress variant="indeterminate" size={24} thickness={4} />
                            </Grid>
                <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                    {t('text.loading') || 'Cargando Información'}
                </Grid>
                        </Grid>}
                </PortletContent>
                
            </Portlet>
        )
    }
}

function FormattedChart(props) {
    return (
        <div>
            <div style={props.style}>
                <Grid
                    container
                    spacing={1}
                >            
                    <Grid item
                        style={{padding: 20}}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        > 
                        <FormControl variant="outlined" size="small">
                            <InputLabel htmlFor="select-objective">{props.t('text.objective') || 'Objetivo'}</InputLabel>
                            <Select
                                label={props.t('text.objective') || 'Objetivo'}
                                variant='outlined'
                                onChange={event => {
                                    const objectivoId = event.target.value
                                    const objetivo = props.listObjectives.find((key) => key['objetivo_id'] == objectivoId)
                                    props.handleFieldChange('First', objetivo)
                                }}
                                native
                                inputProps={{
                                    name: "objetivo",
                                    id: "select-objective",
                                }}
                                value={props.objectiveFirst.objetivo_id}
                            >
                                {props.listObjectives.map((key) => {  
                                    if (key['estado'] !== 'No monitoreo'){
                                        return <option key={key['objetivo_id']} value={key['objetivo_id']}>
                                            {key['objetivo_id']+" - "+key['nombre']}
                                        </option>
                                    }     
                                })}
                            </Select>
                    </FormControl>
                    </Grid> 
                    <Grid item
                        style={{padding: 20}}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        > 
                         <FormControl variant='outlined' size='small'>
                            <InputLabel htmlFor="select-objective-to-compare">{props.t('text.objective-to-compare') || 'Objetivo a comparar'}</InputLabel>
                            <Select
                                label={props.t('text.objective-to-compare') || 'Objetivo a comparar'}
                                variant='outlined'
                                onChange={event => {
                                    const objetivoId = event.target.value
                                    const objetivo = props.listObjectives.find((key) => key['objetivo_id'] == objetivoId)
                                    props.handleFieldChange('Second', objetivo)
                                }}
                                native
                                inputProps={{
                                    name: "objetivo",
                                    id: "select-objective-to-compare",
                                }}
                                size="small"
                                value={props.objectiveSecond.objetivo_id}
                            >
                                {props.listObjectives.map((key) => {  
                                    if (key['estado'] !== 'No monitoreo'){
                                        return <option key={key['objetivo_id']} value={key['objetivo_id']}>
                                            {key['objetivo_id']+" - "+key['nombre']}
                                        </option>
                                    }     
                                })}
                            </Select>
                        </FormControl>
                    </Grid> 
                    <Grid sm={12} style={{marginBottom: 15}}>
                    </Grid>
                    <Grid item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        >
                        <AvailabilitySimplified params={props.params} title={props.t('graph.consolidated-availability.title') || "Disponibilidad"} period="d" id="availability-h" 
                            typePeriod={1} typeGraph={props.params.typegraphFirst} automaticUpdate={true} size="90%" 
                            textSize="25" dataLabelsY="-35" extendView={props.checkedA} isSecondObjective={false} handleTypegraph={props.handleTypegraph}/>
                    </Grid>  
                    <Grid item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        >
                        <AvailabilitySimplified params={props.params} title={props.t('graph.consolidated-availability.title') || "Disponibilidad"} period="d" id="availability-h" 
                            typePeriod={1} typeGraph={props.params.typegraphSecond} automaticUpdate={true} size="90%" 
                            textSize="25" dataLabelsY="-35" extendView={props.checkedA}  isSecondObjective={true} handleTypegraph={props.handleTypegraph}/>
                    </Grid>
                    <Grid item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        > 
                        <ResponseTimeSimplified params={props.params} title={props.t('response-time-general.graph.title') || "Tiempo de Respuesta"} period="d" id="responseTime-h"  
                            typePeriod={1} typeGraph={props.params.typegraphResponseFirst} automaticUpdate={true} 
                            size="90%" textSize="25" dataLabelsY="-35" isSecondObjective={false}  handleTypegraph={props.handleTypegraph}/>
                    </Grid>
                    <Grid item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        > 
                        <ResponseTimeSimplified params={props.params} title={props.t('response-time-general.graph.title') || "Tiempo de Respuesta"} period="d" id="responseTime-h"  
                            typePeriod={1} typeGraph={props.params.typegraphResponseSecond} automaticUpdate={true} 
                            size="90%" textSize="25" dataLabelsY="-35" isSecondObjective={true}  handleTypegraph={props.handleTypegraph}/>
                    </Grid>       
                </Grid>     
            </div>   
        </div>           
    )
}

function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}
CompareObjectives.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(CompareObjectives));
